<!-- 补充资料弹窗 -->
<template>
  <div class="dialog">
    <el-dialog title="补充资料" :visible.sync="isShow" width="500px">
      <div class="row">
        <div class="label">补充信息说明：</div>
        <div class="val">
          <el-input v-model="supplementalMaterialsData.supplement_text" type="textarea" readonly></el-input>
        </div>
      </div>
      <div class="row">
        <div class="label">补充资料图片：</div>
        <div class="val">
          <el-image v-for="(item, index) in supplementalMaterialsData.supplement_images" :key="index" :src="item"
            style="width: 100px; height: 100px; margin-right: 15px;" :preview-src-list="[item]">
          </el-image>
        </div>
      </div>
      <div class="row">
        <div class="label">补充资料文件：</div>
        <div class="val">
          <el-link :href="item" target="_blank" type="primary"
            v-for="(item, index) in supplementalMaterialsData.supplement_files" :key="index">{{ item }}</el-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      supplementalMaterialsData: {
        supplement_text: '',
        supplement_images: [],
        supplement_files: [],
      },
    };
  },
  methods: {
    openDialog(row) {
      this.isShow = true;
      this.supplementalMaterialsData = row
    }
  }
}
</script>
<style scoped>
.dialog {
  width: 500px;

  .row {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .label {
    width: 120px;
    text-align: right;
  }

  .val {
    flex: 1;
  }
}
</style>
